import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["prefixCls", "bordered", "className", "getPopupContainer", "dropdownClassName", "listHeight", "listItemHeight", "size", "notFoundContent", "combobox", "onInputKeyDown", "onKeyDown", "options", "data", "multiple", "tags"];
import * as React from 'react';
import omit from 'rc-util/lib/omit';
import classNames from 'classnames';
import RcSelect, { Option, OptGroup, SelectProps as RcSelectProps } from 'rc-select'; // import { OptionProps } from 'rc-select/lib/Option';

import { ConfigContext } from './config-provider';
import SizeContext from './config-provider/SizeContext'; // import { getTransitionName } from './_util/motion';

import { Warning } from "../../wui-core/src";
import Icon from "../../wui-icon/src";
var isShouldUpdate = Warning.isShouldUpdate;
var defaultClearIcon = /*#__PURE__*/React.createElement(Icon, {
  type: "uf-close-c"
});
var defaultMenuItemSelectedIcon = /*#__PURE__*/React.createElement(Icon, {
  type: "uf-correct-2"
});
var defaultSuffixIcon = /*#__PURE__*/React.createElement(Icon, {
  type: "uf-arrow-down"
}); // export { OptionProps };

var InternalSelect = function InternalSelect(_ref, ref) {
  var _classNames, _classNames2;

  var customizePrefixCls = _ref.prefixCls,
      _ref$bordered = _ref.bordered,
      bordered = _ref$bordered === void 0 ? true : _ref$bordered,
      className = _ref.className,
      getPopupContainer = _ref.getPopupContainer,
      dropdownClassName = _ref.dropdownClassName,
      _ref$listHeight = _ref.listHeight,
      listHeight = _ref$listHeight === void 0 ? 256 : _ref$listHeight,
      _ref$listItemHeight = _ref.listItemHeight,
      listItemHeight = _ref$listItemHeight === void 0 ? 24 : _ref$listItemHeight,
      customizeSize = _ref.size,
      notFoundContent = _ref.notFoundContent,
      combobox = _ref.combobox,
      onInputKeyDown = _ref.onInputKeyDown,
      onKeyDown = _ref.onKeyDown,
      options = _ref.options,
      data = _ref.data,
      multiple = _ref.multiple,
      tags = _ref.tags,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useContext = React.useContext(ConfigContext),
      getContextPopupContainer = _React$useContext.getPopupContainer,
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction,
      virtual = _React$useContext.virtual,
      dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth;

  var size = React.useContext(SizeContext);
  var prefixCls = getPrefixCls('select', customizePrefixCls);
  var rootPrefixCls = getPrefixCls(); // ===================== Attibutes =====================

  React.useEffect(function () {
    var tinperProps = {
      multiple: multiple,
      data: data,
      onKeyDown: onKeyDown,
      tags: tags
    };
    isShouldUpdate("Select", tinperProps);
  }, []);
  var mode = React.useMemo(function () {
    var m = props.mode;

    if (tags) {
      return 'tags';
    }

    if (multiple) {
      return 'multiple';
    }

    if (combobox) {
      // combobox属性依然支持，并且这样传combobox功能可以用
      return 'combobox';
    }

    return m;
  }, [props.mode]);
  var isMultiple = mode === 'multiple' || mode === 'tags'; // ===================== Empty =====================

  var mergedNotFound;

  if (notFoundContent !== undefined) {
    mergedNotFound = notFoundContent;
  } else if (mode === 'combobox') {
    mergedNotFound = null;
  } else {
    mergedNotFound = /*#__PURE__*/React.createElement("span", null, "\u6682\u65E0\u6570\u636E");
  } // ===================== Icons =====================


  var suffixIcon = props.suffixIcon,
      menuItemSelectedIcon = props.menuItemSelectedIcon,
      removeIcon = props.removeIcon,
      clearIcon = props.clearIcon,
      showArrow = props.showArrow;
  var selectProps = omit(props, ['suffixIcon', 'itemIcon']);
  var rcSelectRtlDropDownClassName = classNames(dropdownClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-dropdown-").concat(direction), direction === 'rtl'), _defineProperty(_classNames, "".concat(prefixCls, "-dropdown--multiple"), !!isMultiple), _classNames));
  var mergedSize = customizeSize || size;
  var mergedClassName = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-lg"), mergedSize === 'large'), _defineProperty(_classNames2, "".concat(prefixCls, "-sm"), mergedSize === 'small'), _defineProperty(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _defineProperty(_classNames2, "".concat(prefixCls, "-borderless"), !bordered), _classNames2), className);
  var showArrowProps = showArrow === undefined ? true : showArrow;
  var extral = {
    mode: mode,
    onInputKeyDown: onInputKeyDown || onKeyDown,
    options: options || data,
    showArrow: showArrowProps
  };
  return /*#__PURE__*/React.createElement(RcSelect, _extends({
    ref: ref,
    virtual: virtual,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth
  }, omit(selectProps, ["dropdownMenuStyle", "dataIndex", "filterDropdown", "filterDropdownType", "filterDropdownIncludeKeys"]), {
    // transitionName={getTransitionName(rootPrefixCls, 'slide-up', props.transitionName)}
    listHeight: listHeight,
    listItemHeight: listItemHeight,
    mode: mode,
    prefixCls: prefixCls,
    direction: direction,
    inputIcon: suffixIcon || defaultSuffixIcon,
    menuItemSelectedIcon: isMultiple ? menuItemSelectedIcon || defaultMenuItemSelectedIcon : null,
    removeIcon: removeIcon,
    clearIcon: clearIcon || defaultClearIcon,
    notFoundContent: mergedNotFound,
    className: mergedClassName,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    dropdownClassName: rcSelectRtlDropDownClassName
  }, extral));
};

var SelectRef = /*#__PURE__*/React.forwardRef(InternalSelect);
var Select = SelectRef; // Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;

Select.Option = Option;
Select.OptGroup = OptGroup;
export default Select;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-select/src/index.js